<template>
<div>
  <el-button @click="dialogVisible = true">雪碧图设置</el-button>
  <el-dialog
    :visible.sync="dialogVisible"
    @close="closeDialog"
    @open="openDialog"
    title="雪碧图设置"
    width="1200px"
  >
    <div class="url-wrap">
      <span class="url-text">
        URL：
      </span>
      <upload 
        url="/admin/coin/upload" 
        :data="{ isSprite: true }" :value="spriteUrl" class="upload" @change="handleUrlChanged">
      </upload>
    </div>
    <el-table :data="logoInfo">
      <el-table-column
        label="币种"
      >
        <template slot-scope="scope">
          <div class="logo">
            <span 
              class="logo-img" 
              :style="{
                'background-image': `url(${spriteUrl})`, 
                'background-position': `${scope.row.positionX}px ${scope.row.positionY}px`
              }"
            ></span>
            {{scope.row.coinType}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="坐标 X"
      >
        <template slot-scope="scope">
          <el-input-number :value="scope.row.positionX" @input="handlePositionChange(scope.row.coinType, 'positionX', $event)" controls-position="right" ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column
        label="坐标 Y"
      >
        <template slot-scope="scope">
          <el-input-number :value="scope.row.positionY" @input="handlePositionChange(scope.row.coinType, 'positionY', $event)" controls-position="right" ></el-input-number>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="handleSave">保存</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import Upload from 'components/upload';
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'CurrencySprite',
  components: {
    Upload
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  computed: {
    ...mapState('currencySetting', ['logoInfo', 'spriteUrl'])
  },
  methods: {
    ...mapActions('currencySetting', ['getLogoInfo', 'updateLogoInfo']),
    ...mapMutations('currencySetting', ['setSpriteUrl', 'setLogoInfo']),
    handleUrlChanged(url) {
      this.setSpriteUrl(url);
    },
    handlePositionChange(coinType, position, value) {
      this.setLogoInfo(
        this.logoInfo.map(item => {
          return item.coinType === coinType
            ? {
                ...item,
                [position]: value ? Number(value) : 0
              }
            : item;
        })
      );
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    openDialog() {
      this.getLogoInfo();
    },
    handleSave() {
      this.updateLogoInfo(this.logoInfo).then(() => {
        this.$message.success('保存成功！');
        this.closeDialog();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.url-wrap {
  display: flex;
  align-items: flex-start;
  padding-bottom: 10px;

  .url-text {
    line-height: 40px;
    margin-right: 8px;
  }

  .upload {
    flex: 1;
  }
}

.logo {
  display: flex;
  align-items: center;

  .logo-img {
    margin-right: 8px;
    display: inline-block;
    width: 32px;
    height: 32px;
    background-size: 32px;
  }
}
</style>
